export const trimS3AndDecode = (filePath, prefix) => {
  let displayName = filePath;

  if (
    filePath.startsWith(
      "https://nsdc-online-test.s3.ap-southeast-2.amazonaws.com/pdf/local/"
    )
  ) {
    displayName = filePath.replace(
      `https://nsdc-online-test.s3.ap-southeast-2.amazonaws.com/${prefix}/`,
      ""
    );
  } else if (filePath.startsWith(`${prefix}/`)) {
    displayName = filePath.replace(`${prefix}/`, "");
  }

  if (displayName.includes("?AWSAccessKeyId=")) {
    displayName = displayName.split("?AWSAccessKeyId=")[0];
  }

  try {
    return decodeURIComponent(displayName);
  } catch (error) {
    return displayName;
  }
};
